import React from 'react';

export const Logo: React.FC<React.SVGProps<SVGSVGElement>> = ({ className, ...props }) => {
   return (
      <svg
         version="1.1"
         id="logo-svg"
         viewBox="0 0 400 400"
         className={className}
         fill="currentColor"
         xmlns="http://www.w3.org/2000/svg"
         {...props}
      >
         <defs
            id="defs1">
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath198">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-127.42418,-285.43141)"
                  id="path198" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath200">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-224.54761,-41.105799)"
                  id="path200" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath202">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-40.443076,-148.2973)"
                  id="path202" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath204">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-129.97118,-14.303198)"
                  id="path204" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath206">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-205.25881,-162.894)"
                  id="path206" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath208">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-127.42418,-285.43141)"
                  id="path208" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath210">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-26.881426,-223.63701)"
                  id="path210" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath212">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-108.6108,-209.098)"
                  id="path212" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath214">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-109.09583,-208.07871)"
                  id="path214" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath216">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-126.8382,-14.6379)"
                  id="path216" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath218">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-70.424927,-219.8923)"
                  id="path218" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath220">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-43.372201,-172.2231)"
                  id="path220" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath222">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-67.148327,-216.5161)"
                  id="path222" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath224">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-68.543327,-218.00391)"
                  id="path224" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath226">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-40.663726,-142.19511)"
                  id="path226" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath228">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-69.011627,-218.48211)"
                  id="path228" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath230">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-69.487727,-218.9341)"
                  id="path230" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath232">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-69.956627,-219.4084)"
                  id="path232" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath234">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-70.899377,-220.3498)"
                  id="path234" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath236">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-71.368502,-220.82451)"
                  id="path236" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath238">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-71.837402,-221.3059)"
                  id="path238" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath240">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-72.312227,-221.76231)"
                  id="path240" />
            </clipPath>
            <clipPath
               clipPathUnits="userSpaceOnUse"
               id="clipPath242">
               <path
                  d="M 0,300 H 300 V 0 H 0 Z"
                  transform="translate(-108.6108,-209.098)"
                  id="path242" />
            </clipPath>
         </defs>
         <g
            id="layer-MC0"
            
            
            transform="translate(-1640)">
            <path
               id="path197"
               d="m 0,0 c 2.627,0.441 5.274,0.7 7.935,0.781 6.272,0.19 12.535,0.121 18.795,-0.45 6.488,-0.591 12.907,-1.578 19.251,-3.034 6.196,-1.423 12.234,-3.395 18.183,-5.602 3.961,-1.469 7.74,-3.393 11.533,-5.263 3.656,-1.803 7.221,-3.761 10.691,-5.903 0.921,-0.568 1.263,-1.208 1.257,-2.266 -0.036,-6.583 -0.017,-13.166 -0.017,-19.748 0,-7.759 0,-15.517 -0.001,-23.275 0,-0.47 0.014,-0.942 -0.021,-1.41 -0.016,-0.208 -0.078,-0.484 -0.222,-0.597 -0.338,-0.264 -0.588,0.064 -0.789,0.267 -2.7,2.735 -5.589,5.255 -8.542,7.717 -7.836,6.534 -16.595,11.469 -26.029,15.279 -4.295,1.735 -8.687,3.175 -13.182,4.267 -5.18,1.258 -10.418,2.337 -15.741,2.647 -7.122,0.415 -14.26,0.504 -21.358,-0.538 -1.395,-0.205 -2.801,-0.337 -4.193,-0.56 -5.582,-0.898 -11.05,-2.318 -16.365,-4.192 -7.772,-2.741 -15.257,-6.136 -22.118,-10.788 -4.349,-2.948 -8.601,-6.01 -12.458,-9.592 -0.221,-0.206 -0.523,-0.324 -0.788,-0.483 0.087,0.297 0.128,0.619 0.268,0.888 1.667,3.191 3.161,6.466 4.993,9.578 2.7,4.588 5.754,8.93 8.88,13.227 1.33,1.828 2.728,3.608 4.062,5.433 0.786,1.076 1.568,2.146 2.548,3.06 0.401,0.374 0.838,0.741 1.129,1.194 1.447,2.258 3.528,3.963 5.248,5.984 2.331,2.738 5.043,5.152 7.596,7.701 0.388,0.387 0.789,0.764 1.206,1.119 1.84,1.569 3.687,3.132 5.535,4.692 1.373,1.158 2.702,2.376 4.141,3.446 2.379,1.767 4.841,3.421 7.242,5.157 C -0.842,-0.91 -0.189,-0.686 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1809.8989,19.4248)"
               clipPath="url(#clipPath198)" />
            <path
               id="path199"
               d="m 0,0 c -0.078,0.12 -0.234,0.246 -0.234,0.373 -0.03,71.725 -0.049,143.45 -0.064,215.174 0,0.46 -0.089,0.944 0.217,1.381 0.535,0.276 0.866,-0.17 1.181,-0.431 2.834,-2.352 5.628,-4.751 8.473,-7.09 0.736,-0.605 1.111,-1.266 1.031,-2.216 -0.046,-0.545 -0.007,-1.096 -0.007,-1.645 0,-17.716 -0.002,-35.432 0.006,-53.148 0,-0.82 -0.11,-1.663 0.241,-2.811 0.608,0.882 1.021,1.51 1.464,2.116 0.416,0.568 0.875,1.105 1.297,1.669 4.772,6.376 10.766,11.386 17.638,15.303 7.083,4.038 14.72,6.478 22.871,7.363 5.111,0.554 10.175,0.345 15.252,-0.203 0.923,-0.099 1.091,-0.27 1.086,-1.169 -0.013,-2.366 -0.536,-4.67 -0.976,-6.972 -1.035,-5.421 -2.92,-10.57 -5.506,-15.433 -5.739,-10.795 -13.85,-19.315 -24.742,-25.008 -6.221,-3.251 -12.818,-5.449 -19.821,-6.363 -2.495,-0.325 -4.989,-0.491 -7.498,-0.556 -1.033,-0.027 -1.258,-0.256 -1.3,-1.229 -0.03,-0.704 -0.012,-1.411 -0.012,-2.116 0,-35.04 0.006,-70.08 -0.009,-105.12 C 10.586,7.854 11.094,9.082 8.189,6.539 5.831,4.476 3.421,2.473 1.028,0.45 0.737,0.205 0.443,-0.073 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1939.3968,345.19227)"
               clipPath="url(#clipPath200)" />
            <path
               id="path201"
               d="M 0,0 C 0.061,-1.887 0.122,-3.775 0.183,-5.661 0.128,-5.702 0.04,-5.734 0.022,-5.788 c -0.057,-0.174 0.021,-0.283 0.199,-0.314 0.236,-3.274 0.559,-6.534 1.072,-9.781 0.659,-4.175 1.593,-8.282 2.747,-12.342 1.671,-5.881 3.958,-11.527 6.652,-17.005 1.967,-4 4.219,-7.837 6.8,-11.486 2.124,-3.003 4.269,-5.983 6.649,-8.79 3.905,-4.607 8.268,-8.747 12.885,-12.629 0.535,-0.45 1.161,-0.81 1.49,-1.468 -0.043,-0.678 0.33,-1.214 0.687,-1.711 0.866,-1.204 1.543,-2.521 2.449,-3.712 1.511,-1.985 2.809,-4.129 4.263,-6.165 0.954,-1.336 2.1,-2.534 2.93,-3.94 1.082,-1.834 2.379,-3.474 3.872,-4.977 0.552,-0.555 1.179,-1.076 1.583,-1.729 1.872,-3.022 4.59,-5.315 6.846,-8.004 3.122,-3.721 7.058,-6.649 10.496,-10.072 0.165,-0.165 0.356,-0.308 0.553,-0.434 1.575,-1.01 2.738,-2.581 4.515,-3.315 1.335,-1.582 3.185,-2.513 4.783,-3.761 1.968,-1.536 3.91,-3.117 6.07,-4.393 0.403,-0.238 0.75,-0.572 1.154,-0.809 0.535,-0.315 0.665,-0.84 0.811,-1.369 l -0.213,-0.034 c 0,0 -0.137,0.167 -0.137,0.169 -0.906,0.378 -1.843,0.312 -2.783,0.2 -2.604,-0.041 -5.124,0.598 -7.669,0.997 -2.627,0.411 -5.231,0.975 -7.839,1.501 -3.844,0.775 -7.571,1.983 -11.309,3.143 -5.313,1.651 -10.479,3.694 -15.529,6.02 -8.918,4.108 -17.316,9.085 -25.143,15.027 -7.068,5.365 -13.617,11.294 -19.541,17.895 -6.451,7.19 -12.13,14.945 -16.835,23.395 -0.647,1.162 -1.334,2.302 -1.977,3.466 -0.491,0.888 -1.022,1.764 -1.197,2.79 0.104,0.372 0.246,0.74 0.305,1.12 0.418,2.7 0.793,5.408 1.233,8.105 0.719,4.406 1.867,8.718 3.026,13.022 0.893,3.319 1.807,6.641 2.925,9.889 2.267,6.591 4.83,13.069 8.066,19.259 1.449,2.773 2.907,5.541 4.416,8.28 C -0.236,1.043 -0.233,0.078 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1693.9241,202.27027)"
               clipPath="url(#clipPath202)" />
            <path
               id="path203"
               d="m 0,0 c -0.146,0.529 -0.276,1.054 -0.812,1.369 -0.403,0.237 -0.75,0.571 -1.153,0.809 -2.16,1.276 -4.102,2.857 -6.07,4.393 -1.598,1.248 -3.448,2.179 -4.783,3.761 -1.777,0.734 -2.94,2.305 -4.515,3.315 -0.197,0.126 -0.388,0.269 -0.554,0.434 -3.437,3.423 -7.373,6.351 -10.495,10.072 -2.256,2.689 -4.974,4.982 -6.846,8.004 -0.404,0.653 -1.032,1.174 -1.583,1.729 -1.493,1.504 -2.79,3.143 -3.873,4.977 -0.829,1.406 -1.975,2.604 -2.929,3.94 -1.454,2.036 -2.752,4.18 -4.263,6.165 -0.906,1.191 -1.583,2.508 -2.449,3.712 -0.357,0.497 -0.73,1.033 -0.687,1.711 0.579,-0.08 0.966,-0.489 1.397,-0.817 4.497,-3.427 9.256,-6.435 14.257,-9.076 7.73,-4.082 15.85,-7.134 24.357,-9.118 3.353,-0.782 6.757,-1.349 10.192,-1.716 3.662,-0.392 7.321,-0.755 11.009,-0.824 4.556,-0.085 9.081,0.248 13.604,0.736 3.903,0.42 7.769,1.042 11.583,1.955 10.446,2.5 20.215,6.602 29.383,12.212 6.72,4.112 12.939,8.823 18.5,14.4 0.055,0.056 0.105,0.118 0.166,0.167 0.413,0.332 0.74,1.077 1.264,0.89 0.724,-0.258 0.362,-1.085 0.363,-1.646 0.023,-13.012 0.018,-26.024 0.018,-39.036 0,-0.314 -0.019,-0.629 0.002,-0.941 0.046,-0.696 -0.227,-1.188 -0.834,-1.548 C 82.765,19.15 81.323,18.199 79.823,17.351 73.469,13.759 66.873,10.714 60.022,8.161 54.058,5.939 48.016,4.043 41.806,2.692 38.211,1.91 34.584,1.286 30.935,0.762 25.101,-0.076 19.245,-0.484 13.364,-0.58 8.901,-0.654 4.435,-0.637 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1813.2949,380.92907)"
               clipPath="url(#clipPath204)" />
            <path
               id="path205"
               d="m 0,0 c 1.877,-3.447 3.205,-7.125 4.523,-10.803 2.309,-6.446 3.707,-13.108 4.58,-19.886 0.22,-1.709 0.341,-3.431 0.494,-5.148 0.048,-0.546 -0.232,-0.91 -0.761,-1.013 -1,-0.194 -2.004,-0.388 -3.014,-0.515 -4.991,-0.628 -10.005,-0.923 -15.03,-0.705 -7.064,0.305 -14.084,1.059 -20.914,2.982 -7.027,1.979 -13.833,4.508 -20.316,7.941 -6.766,3.582 -13.013,7.892 -18.735,12.919 -6.084,5.344 -11.42,11.399 -15.952,18.14 -3.727,5.544 -6.975,11.343 -9.519,17.522 -2.392,5.807 -4.2,11.787 -5.447,17.953 -0.685,3.389 -1.14,6.798 -1.506,10.226 -0.058,0.542 -0.029,1.093 -0.041,1.638 0.226,-0.055 0.525,-0.036 0.667,-0.176 1.49,-1.477 2.875,-3.051 4.223,-4.659 0.048,-0.058 0.067,-0.141 0.1,-0.212 0.006,-0.423 0.026,-0.839 0.494,-1.045 l -0.009,0.026 c 0.013,-0.156 -0.015,-0.33 0.045,-0.464 1.472,-3.299 3.733,-6.092 5.854,-8.964 1.108,-1.5 2.528,-2.767 3.66,-4.251 3.012,-3.948 6.929,-6.965 10.474,-10.365 0.056,-0.054 0.116,-0.106 0.18,-0.151 1.538,-1.066 2.952,-2.287 4.41,-3.456 1.086,-0.871 2.15,-1.798 3.428,-2.43 1.111,-0.549 2.152,-1.235 3.243,-1.828 2.196,-1.195 4.402,-2.373 6.611,-3.545 0.899,-0.476 1.888,-0.815 2.713,-1.394 3.127,-2.193 6.842,-3.019 10.262,-4.528 4.296,-0.759 8.366,-2.413 12.718,-3.034 3.308,-0.472 6.562,-1.315 9.937,-1.282 0.31,0.003 0.65,0.007 0.927,-0.107 1.055,-0.432 2.156,-0.346 3.248,-0.354 1.724,-0.013 3.455,0.093 5.17,-0.025 3.301,-0.226 6.53,0.635 9.817,0.528 0.229,-0.008 0.483,0.021 0.689,0.114 C -1.883,0.055 -0.934,-0.047 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1913.6784,182.808)"
               clipPath="url(#clipPath206)" />
            <path
               id="path207"
               d="M 0,0 C -0.189,-0.686 -0.842,-0.91 -1.331,-1.264 -3.732,-3 -6.194,-4.654 -8.573,-6.421 c -1.439,-1.07 -2.768,-2.288 -4.141,-3.446 -1.848,-1.56 -3.695,-3.123 -5.535,-4.692 -0.417,-0.355 -0.818,-0.732 -1.206,-1.119 -2.553,-2.549 -5.265,-4.963 -7.596,-7.701 -1.72,-2.021 -3.801,-3.726 -5.248,-5.984 -0.291,-0.453 -0.728,-0.82 -1.129,-1.194 -0.98,-0.914 -1.762,-1.984 -2.548,-3.06 -1.334,-1.825 -2.732,-3.605 -4.062,-5.433 -3.126,-4.297 -6.18,-8.639 -8.88,-13.227 -1.832,-3.112 -3.326,-6.387 -4.993,-9.578 -0.14,-0.269 -0.181,-0.591 -0.268,-0.888 -0.166,-0.163 -0.331,-0.325 -0.497,-0.487 -0.23,-0.063 -0.385,-0.2 -0.436,-0.439 0,0 -0.047,-0.042 -0.047,-0.042 -0.234,-0.045 -0.376,-0.183 -0.428,-0.415 0,0 -0.054,-0.054 -0.054,-0.054 -0.231,-0.052 -0.371,-0.193 -0.415,-0.427 0,0 -0.041,-0.047 -0.041,-0.047 -0.236,-0.049 -0.379,-0.191 -0.428,-0.428 0,0 -0.046,-0.041 -0.046,-0.041 -0.234,-0.045 -0.376,-0.184 -0.428,-0.416 0,0 -0.053,-0.052 -0.053,-0.052 -0.233,-0.053 -0.373,-0.196 -0.416,-0.432 0,0 -0.037,-0.044 -0.037,-0.044 -0.239,-0.048 -0.383,-0.192 -0.432,-0.43 0,0 -0.043,-0.038 -0.043,-0.038 -0.236,-0.043 -0.379,-0.182 -0.433,-0.414 0,0 -0.053,-0.053 -0.053,-0.053 -0.231,-0.052 -0.369,-0.193 -0.415,-0.426 -0.177,-0.466 -0.559,-0.733 -0.956,-0.988 -0.247,-0.078 -0.399,-0.24 -0.439,-0.499 -1.598,-1.922 -3.224,-3.821 -4.789,-5.77 -4.135,-5.148 -7.647,-10.701 -10.675,-16.561 -2.738,-5.299 -4.991,-10.798 -6.707,-16.512 -0.495,-1.648 -0.954,-3.306 -1.429,-4.959 -0.259,-0.092 -0.346,-0.246 -0.176,-0.491 -0.097,-0.279 -0.194,-0.558 -0.291,-0.837 -0.099,0.12 -0.222,0.228 -0.294,0.363 -2.432,4.557 -4.393,9.329 -6.274,14.127 -1.367,3.488 -2.604,7.027 -3.72,10.612 -2.346,7.539 -4.11,15.197 -5.221,23.01 -0.197,1.384 -0.459,2.759 -0.691,4.139 1.562,3.092 3.677,5.819 5.754,8.561 6.701,8.848 14.388,16.77 23.004,23.75 5.967,4.833 12.317,9.144 19.084,12.83 5.44,2.962 10.999,5.659 16.758,7.927 3.351,1.319 6.738,2.564 10.212,3.54 3.088,0.867 6.175,1.74 9.274,2.563 4.479,1.188 9.068,1.761 13.653,2.34 C -1.872,-0.165 -0.935,-0.093 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1809.8989,19.4248)"
               clipPath="url(#clipPath208)" />
            <path
               id="path209"
               d="m 0,0 c 0.232,-1.379 0.494,-2.754 0.691,-4.138 1.11,-7.814 2.874,-15.472 5.221,-23.01 1.116,-3.586 2.353,-7.124 3.72,-10.613 1.881,-4.798 3.842,-9.569 6.274,-14.127 0.072,-0.135 0.195,-0.242 0.294,-0.363 -0.465,-2.683 -0.912,-5.37 -1.398,-8.049 -0.586,-3.233 -0.923,-6.49 -0.955,-9.773 -0.015,-1.547 -0.379,-3.093 -0.03,-4.648 0.04,-0.179 -0.164,-0.413 -0.255,-0.62 -0.233,0.079 -0.236,1.044 -0.673,0.252 -1.509,-2.74 -2.967,-5.508 -4.416,-8.28 -3.236,-6.19 -5.799,-12.669 -8.066,-19.259 -1.118,-3.248 -2.032,-6.571 -2.925,-9.89 -1.159,-4.304 -2.307,-8.615 -3.026,-13.021 -0.441,-2.698 -0.815,-5.405 -1.233,-8.106 -0.059,-0.38 -0.201,-0.748 -0.305,-1.12 -1.041,1.01 -1.447,2.385 -2.051,3.635 -2.424,5.012 -4.327,10.234 -6.078,15.507 -2.175,6.545 -3.803,13.229 -4.813,20.057 -0.434,2.938 -0.93,5.872 -1.23,8.825 -0.301,2.955 -0.472,5.93 -0.552,8.901 -0.087,3.211 -0.127,6.433 0.037,9.639 0.231,4.526 0.585,9.041 1.229,13.543 0.867,6.052 2.147,11.999 3.769,17.881 1.792,6.497 4.181,12.781 6.903,18.944 1.394,3.154 2.881,6.266 4.615,9.241 C -3.564,-5.693 -2.051,-2.68 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1675.8419,101.81733)"
               clipPath="url(#clipPath210)" />
            <path
               id="path211"
               d="m 0,0 c -0.033,0.071 -0.052,0.154 -0.1,0.212 -1.348,1.608 -2.733,3.182 -4.223,4.659 -0.142,0.14 -0.441,0.121 -0.667,0.176 -0.952,1.837 -0.363,1.879 1.024,2.26 1.268,0.349 2.615,0.629 3.916,0.59 2.29,-0.069 4.494,0.604 6.774,0.538 2.27,-0.066 4.544,-0.004 6.816,-0.018 1.639,-0.01 3.295,0.151 4.889,-0.418 0.143,-0.051 0.31,-0.049 0.465,-0.047 2.587,0.025 5.098,-0.534 7.641,-0.903 6.284,-0.914 12.313,-2.745 18.213,-4.973 5.27,-1.991 10.332,-4.457 15.097,-7.511 2.238,-1.434 4.531,-2.783 6.676,-4.354 6.979,-5.114 13.244,-10.976 18.566,-17.816 0.043,-0.056 0.037,-0.15 0.055,-0.227 -0.546,-0.038 -1.1,-0.03 -1.637,-0.12 -3.161,-0.533 -6.333,-0.91 -9.546,-0.904 -1.407,0.002 -2.819,0.056 -4.218,-0.197 -0.3,-0.054 -0.627,-0.072 -0.922,-0.014 -1.476,0.294 -2.97,0.241 -4.453,0.202 -2.751,-0.073 -5.489,0.228 -8.173,0.652 -4.383,0.693 -8.781,1.376 -13.047,2.715 -4.932,1.547 -9.828,3.161 -14.502,5.394 -3.039,1.452 -6.041,2.978 -8.911,4.732 -2.735,1.671 -5.458,3.394 -8.006,5.332 -3.481,2.647 -6.956,5.326 -10.022,8.475 -0.327,0.335 -0.678,0.666 -1.22,0.546 0,0 0.009,-0.026 0.009,-0.026 C 0.634,-0.553 0.356,-0.258 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1784.8144,121.20267)"
               clipPath="url(#clipPath212)" />
            <path
               id="path213"
               d="m 0,0 c 0.542,0.121 0.893,-0.21 1.22,-0.546 3.066,-3.149 6.541,-5.828 10.022,-8.475 2.548,-1.938 5.271,-3.661 8.006,-5.332 2.87,-1.753 5.872,-3.28 8.911,-4.731 4.674,-2.234 9.57,-3.847 14.502,-5.395 4.266,-1.338 8.664,-2.022 13.047,-2.715 2.684,-0.424 5.422,-0.725 8.173,-0.652 1.483,0.04 2.977,0.092 4.453,-0.201 0.295,-0.059 0.622,-0.041 0.922,0.013 1.399,0.253 2.811,0.199 4.218,0.197 3.213,-0.005 6.385,0.371 9.546,0.904 0.537,0.091 1.091,0.082 1.637,0.12 2.747,-3.214 5.191,-6.653 7.355,-10.278 1.358,-2.275 2.54,-4.656 3.782,-6.999 0.178,-0.336 0.249,-0.728 0.369,-1.095 -0.934,-0.047 -1.883,0.055 -2.777,-0.35 -0.206,-0.094 -0.46,-0.122 -0.689,-0.115 -3.287,0.107 -6.516,-0.754 -9.817,-0.527 -1.715,0.118 -3.446,0.012 -5.17,0.024 -1.092,0.008 -2.193,-0.078 -3.247,0.354 -0.278,0.114 -0.618,0.111 -0.928,0.108 -3.375,-0.033 -6.629,0.81 -9.937,1.281 -4.352,0.621 -8.422,2.275 -12.718,3.035 -3.42,1.508 -7.135,2.335 -10.262,4.528 -0.825,0.578 -1.814,0.917 -2.713,1.394 -2.209,1.171 -4.415,2.35 -6.611,3.544 -1.091,0.593 -2.132,1.279 -3.243,1.828 -1.278,0.632 -2.342,1.559 -3.428,2.43 -1.458,1.169 -2.872,2.39 -4.41,3.457 -0.064,0.044 -0.124,0.096 -0.18,0.15 -3.545,3.4 -7.462,6.417 -10.474,10.365 -1.132,1.484 -2.552,2.751 -3.66,4.251 C 3.778,-6.556 1.518,-3.762 0.045,-0.464 -0.015,-0.329 0.013,-0.155 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1785.4611,122.56173)"
               clipPath="url(#clipPath214)" />
            <path
               id="path215"
               d="M 0,0 C 0.94,0.112 1.877,0.178 2.783,-0.2 1.823,-0.581 0.905,-0.384 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1809.1176,380.4828)"
               clipPath="url(#clipPath216)" />
            <path
               id="path217"
               d="M 0,0 C 0.052,0.232 0.194,0.371 0.429,0.416 0.415,0.145 0.274,0.004 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1733.8999,106.81027)"
               clipPath="url(#clipPath218)" />
            <path
               id="path219"
               d="M 0,0 C -0.17,0.246 -0.083,0.399 0.176,0.491 0.292,0.264 0.241,0.098 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1697.8296,170.3692)"
               clipPath="url(#clipPath220)" />
            <path
               id="path221"
               d="M 0,0 C 0.04,0.26 0.192,0.421 0.439,0.5 0.432,0.212 0.281,0.049 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1729.5311,111.31187)"
               clipPath="url(#clipPath222)" />
            <path
               id="path223"
               d="M 0,0 C 0.046,0.232 0.184,0.374 0.415,0.425 0.412,0.152 0.269,0.014 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1731.3911,109.32813)"
               clipPath="url(#clipPath224)" />
            <path
               id="path225"
               d="M 0,0 C -0.178,0.031 -0.256,0.14 -0.198,0.314 -0.18,0.369 -0.093,0.4 -0.037,0.441 -0.025,0.294 -0.012,0.147 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1694.2183,210.40653)"
               clipPath="url(#clipPath226)" />
            <path
               id="path227"
               d="M 0,0 C 0.054,0.232 0.197,0.372 0.432,0.415 0.416,0.143 0.272,0.005 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1732.0155,108.69053)"
               clipPath="url(#clipPath228)" />
            <path
               id="path229"
               d="M 0,0 C 0.049,0.239 0.193,0.382 0.432,0.431 0.426,0.149 0.282,0.005 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1732.6503,108.08787)"
               clipPath="url(#clipPath230)" />
            <path
               id="path231"
               d="M 0,0 C 0.043,0.236 0.183,0.379 0.416,0.432 0.412,0.158 0.272,0.016 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1733.2755,107.45547)"
               clipPath="url(#clipPath232)" />
            <path
               id="path233"
               d="M 0,0 C 0.049,0.236 0.191,0.379 0.428,0.428 0.431,0.14 0.288,-0.002 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1734.5325,106.20027)"
               clipPath="url(#clipPath234)" />
            <path
               id="path235"
               d="M 0,0 C 0.044,0.234 0.183,0.375 0.415,0.427 0.408,0.157 0.27,0.015 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1735.158,105.56733)"
               clipPath="url(#clipPath236)" />
            <path
               id="path237"
               d="M 0,0 C 0.052,0.231 0.194,0.37 0.427,0.414 0.412,0.145 0.271,0.006 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1735.7832,104.92547)"
               clipPath="url(#clipPath238)" />
            <path
               id="path239"
               d="M 0,0 C 0.051,0.24 0.206,0.376 0.436,0.439 0.418,0.167 0.276,0.017 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1736.4163,104.31693)"
               clipPath="url(#clipPath240)" />
            <path
               id="path241"
               d="M 0,0 C 0.356,-0.258 0.634,-0.553 0.494,-1.045 0.026,-0.839 0.006,-0.423 0,0"
               fill="currentColor" fillOpacity="1" fillRule="nonzero" stroke="none"
               transform="matrix(1.3333333,0,0,-1.3333333,1784.8144,121.20267)"
               clipPath="url(#clipPath242)" />
         </g>
      </svg>
   );
};
